import React, { useState, useEffect, useMemo } from "react";
import { Button, useTheme, Box, IconButton, Stack, Dialog, DialogContent, DialogTitle, CircularProgress, Tooltip, Typography, Checkbox, Divider, Select, MenuItem } from "@mui/material";
import { tokens } from "../../assets/theme";
import { useQuery } from "@tanstack/react-query";
import { useLocalStorage } from "../../hooks/useLocalStorage";
//Components
import AxionControls from "../../components/controls/AxionControls";
import { pushErrorMessage } from "../../utils/notifications";
import AxionConfirmation from '../../components/controls/AxionConfirmation';
import Controls from "../../components/controls/Contols";
//Hooks

//import { getDepartments, postDepartment, patchDepartment } from "../../fetchers/departments";
import { getTopLevelCategories, postTopLevelCategory, patchTopLevelCategory } from "../../fetchers/incidentTopLevelCategory";
import { getDepartments } from "../../fetchers/departments";
import { getCategories, postCategory, patchCategory } from "../../fetchers/incidentCategory";
import { getTopLevelGroups } from "../../fetchers/incidentTopLevelCategoryGroup";
//Icons
import SaveIcon from '@mui/icons-material/Save';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
//Language
import messages from "./messages";
import { FormattedMessage, useIntl } from "react-intl";
import { event } from "jquery";


export default function EditTopLevelCategories(props) {

    const { formatMessage } = useIntl();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [companyKey, setCompanyKey] = useLocalStorage("companyKey", 1);
    const [newCategory, setNewCategory] = useState({ id: null, name: "", companyId: companyKey, sortorder: 0, taskIncidentCategoryTopLevelGroupId: null });
    const [showAddCategory, setShowAddCategory] = useState(true);
    const [openDialog, toggleOpenDialog] = React.useState(false);
    //const [groups, setGroups] = useState([{ id: 1, name: "Operations" }, { id: 2, name: "Management" }]);
    const [openCategoriesDialog, toggleOpenCategoriesDialog] = React.useState(false);
    const [editTopLevelCategory, setEditTopLevelCategory] = useState({});

    const topLevelQuery = useQuery(
        ["Categories", companyKey],
        () => getTopLevelCategories(companyKey),
        {}
    );

    // const groupQuery = useQuery(
    //     ["Groups", companyKey],
    //     () => getTopLevelCategories(companyKey),
    //     {}
    // );

    const departmentsQuery = useQuery(
        ["Departments", companyKey],
        () => getDepartments(companyKey),
        {}
    );

    const categoriesQuery = useQuery(
        ["categories", companyKey],
        () => getCategories(companyKey),
        {}
    );

    const groupsQuery = useQuery(
        ["Groups", companyKey],
        () => getTopLevelGroups(companyKey),
        {}
    );


    const handleCloseDialog = () => {
        setNewCategory({ id: null, name: "", sortorder: 0, companyId: companyKey, taskIncidentCategoryTopLevelGroupId: null });
        toggleOpenDialog(false);
    };

    const handleCloseCategoriesDialog = () => {
        //  setNewCategory({ id: null, name: "", sortorder: 0, companyId: companyKey, taskIncidentCategoryTopLevelGroupId: null });
        toggleOpenCategoriesDialog(false);
    };

    const handleAddCategory = () => {

        console.log("new/edit Category", newCategory);

        if (newCategory.id !== null) {
            patchTopLevelCategory(newCategory).then(() => {
                topLevelQuery.refetch();
                handleCloseDialog();
            }).catch((error) => {
                console.log(error);
                //setShowBackdrop(false);
                pushErrorMessage(formatMessage(messages.could_not_update_category));
            });
        } else {

            postTopLevelCategory(newCategory).then(() => {
                topLevelQuery.refetch();
                handleCloseDialog();
            }).catch((error) => {
                console.log(error);
                //setShowBackdrop(false);
                pushErrorMessage(formatMessage(messages.could_not_create_category));
            });
        }
    }

    const handleSaveTopLevelCategory = () => {
        patchTopLevelCategory(editTopLevelCategory).then(() => {
            topLevelQuery.refetch();
            handleCloseCategoriesDialog();
        }).catch((error) => {
            console.log(error);
            //setShowBackdrop(false);
            pushErrorMessage(formatMessage(messages.could_not_update_category));
        });
    }




    const handlePrepareAddCategory = () => {

        toggleOpenDialog(true);
        setShowAddCategory(true);
        //setShowAddValue(false);
    }

    const handleNameChange = (event) => {
        let category = { ...newCategory };
        category.name = event.target.value;
        setNewCategory(category);
    }
    const handleSortOrderChange = (event) => {
        let category = { ...newCategory };
        category.sortorder = event.target.value;
        setNewCategory(category);
    }
    const handleGroupChange = (event) => {
        let category = { ...newCategory };
        category.taskIncidentCategoryTopLevelGroupId = event.target.value;
        setNewCategory(category);
    }

    const handleCategoryChange = (event) => {
        let category = { ...editTopLevelCategory };

        console.log("handleCategoryChange", category);

        if (event.target.checked) {
            // let dept = departmentsQuery.data.find(d => d.id.toString() === event.target.id);

            let cat = categoriesQuery.data.find(c => c.id.toString() === event.target.id);
            console.log("edit cat", cat);
            if (cat !== null) {
                if (category.taskIncidentCategories === null || category.taskIncidentCategories === undefined) {
                    category.taskIncidentCategories = [];
                }
                category.taskIncidentCategories.push(cat);
            }
        } else {
            console.log("delete");
            category.taskIncidentCategories = category.taskIncidentCategories.filter(d => d.id.toString() !== event.target.id);
        }

        setEditTopLevelCategory(category);
    }

    const handleEditTopLevelCategoryClick = (id) => {
        var dim = topLevelQuery.data?.filter(d => d.id === id);

        var category = { ...newCategory };
        category.id = id;
        category.name = dim[0].name;
        category.sortorder = dim[0].sortorder;
        category.taskIncidentCategoryTopLevelGroupId = dim[0].taskIncidentCategoryTopLevelGroupId;

        setNewCategory(category);
        toggleOpenDialog(true);
    }

    const handleEditCategoryClick = (id) => {

        let edit = topLevelQuery.data.find(d => d.id === id);

        setEditTopLevelCategory(edit);

        //alert('Pling!');
        // var dim = topLevelQuery.data?.filter(d => d.id === id);

        // var category = { ...newCategory };
        // category.id = id;
        // category.name = dim[0].name;
        // category.sortorder = dim[0].sortorder;
        // category.taskIncidentCategoryTopLevelGroupId = dim[0].taskIncidentCategoryTopLevelGroupId;

        // setNewCategory(category);
        toggleOpenCategoriesDialog(true);
    }

    function getGroupName(id) {
        var group = groupsQuery.data?.find(g => g.id === id);
        return group?.name;
    }

    function getDepartmentName(id) {
        var department = departmentsQuery?.data?.filter(g => g.id === id);
        if (department === null || department === undefined) return "???";
        return department[0].name;
    }

    let spinner = <div
        style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
        }}
    >
        <CircularProgress color="secondary" />
    </div>

    if (categoriesQuery.isLoading) {
        return (spinner);
    }
    if (topLevelQuery.isLoading) {
        return (spinner);
    }
    if (departmentsQuery.isLoading) {
        return (spinner);
    }
    if (groupsQuery.isLoading) {
        return (spinner);
    }
    

    console.log("TopLevelQuery", topLevelQuery.data);
    console.log("categoriesQuery.data", categoriesQuery.data);
    console.log("editTopLevelCategory", editTopLevelCategory);
    return (
        <>
            <Box padding="30px"> </Box>
            <Box width="80%">
                <Box width="100%" justifyContent="flex-start" alignItems="center" display="flex" marginTop="10px" marginBottom="20px" marginLeft="15px">

                    <Controls.Button
                        onClick={handlePrepareAddCategory}
                        text={formatMessage(messages.add_category)}
                        startIcon={<AddCircleOutlinedIcon />}
                        disabled={topLevelQuery?.data?.length > 10}
                        sx={{
                            "&:hover": {
                                backgroundColor: colors.dashbordGreen[700],
                            },
                            backgroundColor: colors.dashbordGreen[500],
                            color: "#000000",
                        }}
                    />
                </Box>
                {/* {(dimensionsQuery?.data?.length > 0) && <Box marginTop="20px" color="#ffffff" marginLeft="10px">Dimensions and values</Box>} */}
                <Stack direction="column" width="100%" overflow="hidden" backgroundColor={colors.primary[300]} marginTop="5px" color="#ffffff" spacing="1px" marginLeft="15px">
                    <Stack backgroundColor={colors.primary[400]} direction="row" width="100%" marginLeft="10px">
                        <Box width="40%" alignItems="center" justifyContent="flex-start" display="flex" padding="10px"><FormattedMessage {...messages.topLevelCategories} /></Box>
                        <Box width="20%" alignItems="center" justifyContent="center" display="flex" padding="10px"><FormattedMessage {...messages.order} /></Box>
                        <Box width="20%" alignItems="center" justifyContent="flex-start" display="flex" padding="10px"><FormattedMessage {...messages.organization} /></Box>
                        <Box width="20%" alignItems="center" justifyContent="flex-end" display="flex" padding="10px"><FormattedMessage {...messages.edit} /></Box>
                    </Stack>
                    {topLevelQuery?.data?.sort((a, b) => (a.sortorder < b.sortorder) ? 1 : -1).sort((a, b) => (a.taskIncidentCategoryTopLevelGroupId > b.taskIncidentCategoryTopLevelGroupId) ? 1 : -1).map((a) => {
                        return (
                            <>
                                <Stack direction="row" width="100%" backgroundColor={colors.primary[500]}>

                                    <Box width="40%" justifyContent="flex-start" alignItems="center" display="flex" marginLeft="10px" onClick={() => handleEditTopLevelCategoryClick(a.id)}>{a.name}</Box>
                                    <Box width="20%" justifyContent="center" alignItems="center" display="flex" marginLeft="10px">{a.sortorder}</Box>
                                    <Box width="20%" justifyContent="flex-start" alignItems="center" display="flex" paddingLeft="10px" marginLeft="10px">{getGroupName(a.taskIncidentCategoryTopLevelGroupId) || "???"}</Box>
                                    <Box width="20%" justifyContent="flex-end" alignItems="center" display="flex" marginRight="10px">

                                        <Tooltip title={<Typography fontSize="12px"><FormattedMessage {...messages.edit_category} /> {a.name}</Typography>}>
                                            <IconButton onClick={() => { handleEditTopLevelCategoryClick(a.id) }}><EditOutlinedIcon /></IconButton>
                                        </Tooltip>

                                        <Tooltip title={<Typography fontSize="12px"><FormattedMessage {...messages.add_edit_categories} /></Typography>}>
                                            <IconButton onClick={() => { handleEditCategoryClick(a.id) }}><AddCircleOutlinedIcon /></IconButton>
                                        </Tooltip>




                                        {/* <Tooltip title={<Typography fontSize="12px">{a.values.length > 0 ? <FormattedMessage {...messages.cannot_remove_dim} /> : <FormattedMessage {...messages.remove_dim} />}</Typography>}>
                                            <span>
                                                <IconButton onClick={() => { handleDeleteDimension(a.id) }} disabled={a.values.length > 0}><DeleteOutlinedIcon /></IconButton>
                                            </span>
                                        </Tooltip> */}
                                    </Box>
                                </Stack>
                                {a?.taskIncidentCategories?.map((x) => {
                                    return (
                                        <Stack direction="row" width="100%" backgroundColor={colors.primary[800]} marginLeft="20px" padding="5px" >
                                            <Box width="30%" marginLeft="20px">{x.name}</Box><Box width="30%">{getDepartmentName(x.departmentId)}</Box><Box width="30%">{x.sortOrder}</Box>
                                        </Stack>
                                    )
                                }
                                )}

                                {/* <Stack direction="row" backgroundColor={colors.primary[500]}><Box width="30%">Code</Box><Box width="30%">Name</Box><Box width="30%">Value</Box></Stack> */}



                            </>
                        )
                    })}
                    <Box padding="0px"> </Box>
                </Stack>
            </Box>

            <Dialog open={openDialog} onClose={handleCloseDialog} m={0} width="400px">
                <Box m={0} sx={{ backgroundColor: colors.primary[400], borderRadius: "4px" }} width="400px" >
                    {/* <form onSubmit={handleAddDimension}> */}
                    <DialogTitle>{(newCategory.id === null) ? <FormattedMessage {...messages.add_a_new_category} /> : <FormattedMessage {...messages.edit_category} />}</DialogTitle>
                    <DialogContent>
                        <Stack direction="column" width="100%" overflow="hidden" spacing={(1)}>
                            <Box><AxionControls.AxionTextBox
                                label={<FormattedMessage {...messages.lbl_name} />}
                                value={newCategory.name}
                                autoComplete="new-password"
                                inputProps={{ autoComplete: 'new-password' }}
                                onChange={(event) =>
                                    handleNameChange(event)
                                }
                            /></Box>
                            <Box><AxionControls.AxionTextBox
                                label={<FormattedMessage {...messages.order} />}
                                value={newCategory.sortorder}
                                autoComplete="new-password"
                                inputProps={{ autoComplete: 'new-password' }}
                                onChange={(event) =>
                                    handleSortOrderChange(event)
                                }
                            /></Box>
                            {/* <Box><AxionControls.AxionTextBox
                                label={<FormattedMessage {...messages.organization} />}
                                value={newCategory.taskIncidentCategoryTopLevelGroupId}
                                autoComplete="new-password"
                                inputProps={{ autoComplete: 'new-password' }}
                                onChange={(event) =>
                                    handleGroupChange(event)
                                }
                            /></Box> */}
                            <Box>
                            <Select
                                sx={{ width: '100%', marginTop: '10px' }}
                                labelId="toplevel-label"
                                id="toplevel-select"
                                value={newCategory.taskIncidentCategoryTopLevelGroupId || 0}
                                //sx={{ width: '200px' }}
                                label={<FormattedMessage {...messages.organization} />} 
                                onChange={(event) =>
                                    handleGroupChange(event)}
                            >
                                <MenuItem key={0} value={0} ><FormattedMessage {...messages.noneSelected} /></MenuItem>
                                {groupsQuery?.data?.sort((a, b) => (a.sortorder > b.sortorder) ? 1 : -1).map((t) => (
                                    <MenuItem key={t.id} value={t.id} >
                                        {t.name}
                                    </MenuItem>
                                ))}
                            </Select>
                            </Box>
                        </Stack>
                        <Stack direction="row" width="100%" overflow="hidden" marginTop="15px" display="flex" justifyContent="flex-end">
                            <Controls.Button
                                text={<FormattedMessage {...messages.btn_close} />}
                                onClick={handleCloseDialog}
                                // startIcon={<SaveIcon />}
                                sx={{
                                    "&:hover": {
                                        backgroundColor: "#535560",
                                    },
                                    backgroundColor: colors.primary[300],
                                    color: "#000000",

                                }}
                            />
                            <Controls.Button
                                marginLeft="10px"
                                text={formatMessage(messages.save_category)}
                                onClick={handleAddCategory}
                                startIcon={<SaveIcon />}
                                sx={{
                                    "&:hover": {
                                        backgroundColor: colors.dashbordGreen[700],
                                    },
                                    backgroundColor: colors.dashbordGreen[500],
                                    color: "#000000",
                                    marginLeft: "10px"
                                }}
                            />
                        </Stack>
                    </DialogContent>
                </Box>
            </Dialog>


            <Dialog open={openCategoriesDialog} onClose={handleCloseCategoriesDialog} m={0} width="500px">
                <Box m={0} sx={{ backgroundColor: colors.primary[400], borderRadius: "4px" }} width="500px" >
                    {/* <form onSubmit={handleAddDimension}> */}
                    <DialogTitle><FormattedMessage {...messages.add_categories} /></DialogTitle>
                    <DialogContent>
                        <Stack direction="column" width="100%" overflow="hidden" spacing="1px" backgroundColor={colors.primary[300]}>
                            <Stack direction="row" width="100%" display="flex" justifyContent="flex-start" alignItems="center" backgroundColor={colors.primary[300]} height="35px">
                                <Box width="10%" display="flex" justifyContent="flex-start" alignItems="center"></Box>
                                <Box width="45%" display="flex" justifyContent="flex-start" alignItems="center"><FormattedMessage {...messages.category} /></Box>
                                <Box width="45%" display="flex" justifyContent="flex-start" alignItems="center"><FormattedMessage {...messages.department} /></Box>
                            </Stack>

                            <Stack direction="column" width="100%" display="flex" justifyContent="flex-start" alignItems="center" spacing="1px">
                                {categoriesQuery?.data?.map((c) => {
                                    return (
                                        <Stack direction="row" width="100%" display="flex" justifyContent="flex-start" alignItems="center" spacing="0px" height="30px" backgroundColor={colors.primary[400]}>
                                            <Checkbox
                                                checked={editTopLevelCategory.taskIncidentCategories?.some(cat => cat.id === c.id)}
                                                onChange={handleCategoryChange}
                                                inputProps={{ 'aria-label': 'controlled' }}
                                                id={c.id}
                                                sx={{
                                                    width: '10%',
                                                    //color: colors.dashbordGreen[500],
                                                    '&.Mui-checked': {
                                                        color: colors.dashbordGreen[500],
                                                    },
                                                }}
                                            />
                                            <Box width="45%">{c.name}</Box>
                                            <Box width="45%">{c.department?.name}</Box>
                                        </Stack>

                                    )
                                })}

                            </Stack>
                            <Divider></Divider>

                        </Stack>
                        <Stack direction="row" width="100%" overflow="hidden" marginTop="15px" display="flex" justifyContent="flex-end">
                            <Controls.Button
                                text={<FormattedMessage {...messages.btn_close} />}
                                onClick={handleCloseCategoriesDialog}
                                // startIcon={<SaveIcon />}
                                sx={{
                                    "&:hover": {
                                        backgroundColor: "#535560",
                                    },
                                    backgroundColor: colors.primary[300],
                                    color: "#000000",

                                }}
                            />
                            <Controls.Button
                                marginLeft="10px"
                                text={(newCategory.id === null) ? <FormattedMessage {...messages.update_category} /> : <FormattedMessage {...messages.update_category} />}
                                onClick={handleSaveTopLevelCategory}
                                startIcon={<SaveIcon />}
                                sx={{
                                    "&:hover": {
                                        backgroundColor: colors.dashbordGreen[700],
                                    },
                                    backgroundColor: colors.dashbordGreen[500],
                                    color: "#000000",
                                    marginLeft: "10px"
                                }}
                            />
                        </Stack>
                    </DialogContent>
                </Box>
            </Dialog>


            {/* <AxionConfirmation open={openConfirmationDimension} title={confirmationTitle} message={confirmationMessage} onConfirm={doDeleteDimension} onCancel={cancelDeleteDimension} cancelText={formatMessage(messages.no)} confirmText={formatMessage(messages.yes)} />
            <AxionConfirmation open={openConfirmationValue} title={confirmationTitle} message={confirmationMessage} onConfirm={doDeleteDimensionValue} onCancel={cancelDeleteDimensionValue} cancelText={formatMessage(messages.no)} confirmText={formatMessage(messages.yes)} /> */}



        </>

    )

}